/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @flow
 */

import React from 'react';
import cn from 'classnames';
import { ButtonGroup, Button, Box } from '@material-ui/core';
import useStyles from './useStyles';

const Header = ({ onChangeSmsType, isCustomSmsType }) => {
  const classes = useStyles();
  return (
    <Box className={classes.header}>
      <ButtonGroup size="small" color='primary' aria-label="sms-type-option">
        <Button
          className={cn(classes.headerBtn, { [classes.selectButtonGrp]: !isCustomSmsType })}
          onClick={onChangeSmsType}
        >
          Standard
        </Button>
        <Button
          className={cn(classes.headerBtn, { [classes.selectButtonGrp]: isCustomSmsType })}
          onClick={onChangeSmsType}
        >
          Custom
        </Button>
      </ButtonGroup>
    </Box>
  );
};

export default Header;
